import React from 'react'
import { connect } from 'react-redux'
import { doGetAutoNumberList } from '../../reducers/actions'
import AutoNumberDiv from './AutoNumberDiv'
import AutoNumberRuleListDiv from './AutoNumberRuleListDiv'
import AutoNumberSequenceListDiv from './AutoNumberSequenceListDiv'
class AutoNumberListDiv extends React.Component {
  state = {}
  componentDidMount = () => {
    this.handleInitAutoNumber()
  }
  handleInitAutoNumber = () => {
    const { onSave, onClose, dispatch } = this.props
    dispatch(doGetAutoNumberList({
      onEnd: ({ errorMessage, initValues基本信息 }) => {
        if (errorMessage) {
          Tyan.pubForm.showError(errorMessage)
        }
        else if (initValues基本信息) {
          this.setState({ initValues基本信息 })
        }
      }
    }))
  }
  handleAddAutoNumber = (data) => {
    Tyan.pubForm.showDialog('自动编号设置', props => <AutoNumberDiv {...props} id={-1} onSave={this.handleInitAutoNumber} />)
    this.setState({})
  }

  handleEditAutoNumber = (data) => {
    Tyan.pubForm.showDialog('自动编号设置', props => <AutoNumberDiv {...props} id={data.id} onSave={this.handleInitAutoNumber} />)
    this.setState({})
  }

  handlerClose = () => {
    const { onClose } = this.props
    onClose && onClose()
  }

  fieldset模板 = () => {
    return [{
      _grid: '', name: '模板', rowNumbers: true, minRows: 5,
      columns: [
        { _text: '名称', minWidth: 500, flex: 1 },
        {
          _button: '设置', icon: 'edit', minWidth: 150, handler: (data, record) => {
            Tyan.pubForm.showDialog('自动编号规则设置(' + record.名称 + ')', props => <AutoNumberRuleListDiv {...props} AutoNumberID={record.id} />)
          }
        },
        {
          _button: '起始编号设置', icon: 'edit', minWidth: 150, handler: (data, record) => {
            Tyan.pubForm.showDialog('起始编号设置(' + record.名称 + ')', props => <AutoNumberSequenceListDiv {...props} AutoNumberID={record.id} />)
          }
        },
      ],
      onDoubleTap: this.handleEditAutoNumber,
    }]
  }

  render = () => {
    const { showBody: Body } = this.props

    return <Body data={this} maxWidth={1200}
      controls={
        [
          { _button: '添加', handler: this.handleAddAutoNumber },
          { _button: '关闭', handler: this.handlerClose },
        ]}
      fieldsets={[
        { title: '', name: '基本信息', _fieldset: this.fieldset模板(), flex: 1 },
      ]}
    />
  }
}

export default connect()(AutoNumberListDiv)